import s from './PriceCard.module.scss'
import type { PriceCardProps } from './PriceCard.props'

export function PriceCard({ total, price1, price2 }: PriceCardProps) {
  return (
    <div className={s.card}>
      <div className={s.wrapper}>
        <h3 className={s.title}>First-Time Total:</h3>
        <span className={s.titlePrice}>{total}</span>
      </div>

      <p className={s.text}>Save by scheduling Regular Bi-weekly or Monthly Cleaning!</p>

      <div className={s.priceWrapper}>
        <div className={s.wrapper}>
          <span className={s.item}>If Bi-weekly:</span>
          <span className={s.itemPrice}>{price1}</span>
        </div>

        <div className={s.wrapper}>
          <span className={s.item}>If Monthly:</span>
          <span className={s.itemPrice}>{price2}</span>
        </div>
      </div>
    </div>
  )
}
